(ns ui.view.card.counterparty-diligence-screening.view
  (:require
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.card-title :as card-title]
   [re-frame.core :as rf]
   [common.localization :as loc]
   [ui.view.card.counterparty-diligence-screening.model :as model]
   [ui.view.card.counterparty-diligence-screening.sub :as sub]
   [ui.view.card.counterparty-diligence-screening.event :as event]
   [ui.components.button.view :as button]
   [common.schema.entities.counterparty-diligence.person :as person-diligence-schema]
   [ui.components.modal.view :as modal]
   [ui.util :as uu]
   [ui.state.session.sub :as session-sub]
   [ui.view.card.counterparty-diligence-screening.tables :as tables]
   [ui.editors.labelled-input.view :as labelled-input]
   [common.country :as country]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.toggle.view :as toggle]))

(defn open-send-to-screening-modal-button
  [{:keys [modal-type ctx] :as _props}]
  (let [selected-legal-entities @(rf/subscribe [::sub/selected-legal-entities ctx])
        selected-natural-persons @(rf/subscribe [::sub/selected-natural-persons ctx])
        disabled? (case modal-type
                    :natural-persons
                    (empty? selected-natural-persons)

                    :legal-entities-and-key-persons
                    (empty? selected-legal-entities))]
    [button/sm-primary-solid
     {:disabled? disabled?
      :tooltip (when disabled?
                 (case modal-type
                   :natural-persons (loc/tr :select-at-least-one-person)
                   :legal-entities-and-key-persons (loc/tr :select-at-least-one-legal-entity)))
      :on-click #(rf/dispatch [::event/open-send-to-screening-modal
                               ctx
                               {:modal-type modal-type}])}
     (loc/tr :send-to-riskscreen)]))

(defn continuous-screening-toggle
  [{:keys [ctx]}]
  (let [counterparty-diligence @(rf/subscribe [::sub/counterparty-diligence ctx])
        company-diligence? (-> counterparty-diligence
                               :entity/type
                               (= :entity.type/company-counterparty-diligence))

        screening-status (if company-diligence?
                           (:company-counterparty-diligence/screening-status counterparty-diligence)
                           (:person-counterparty-diligence/screening-status counterparty-diligence))

        screening-status (or screening-status :screening-status/inactive)]
    [:div
     {:class "flex items-center gap-2"}
     [toggle/toggle
      {:checked? (= screening-status :screening-status/active)
       :on-change (fn [checked?]
                    (rf/dispatch-sync [::event/change-screening-status
                                       ctx
                                       (if checked?
                                         :screening-status/active
                                         :screening-status/inactive)]))}]

     [:div
      [:p
       {:class "font-medium m-0 text-nowrap"}
       (loc/tr :continuous-screening)]
      [:p
       {:class "text-sm m-0 text-base-light-text-paler leading-none"}
       (if company-diligence?
         (loc/tr :screen-legal-entity-and-key-persons-daily)
         (loc/tr :screen-person-daily))]]]))

(defn send-to-screening-modal
  [{:keys [ctx] :as _props}]
  (let [state @(rf/subscribe [::sub/send-to-screening-modal-state ctx])
        {:keys [open? screening-method modal-type]} state
        sending-to-screening? @(rf/subscribe [::sub/sending-to-screening? ctx])]
    (when open?
      (let [title (case modal-type
                    :legal-entities-and-key-persons
                    (loc/tr :send-legal-entities-and-key-persons-to-screening)
                    :natural-persons
                    (loc/tr :send-persons-to-screening))

            method-options
            [{:value :one-time
              :title (loc/tr :one-time-screening)
              :description (case modal-type
                             :legal-entities-and-key-persons
                             (loc/tr :legal-entities-and-key-persons-will-be-screened-once-now)

                             :natural-persons
                             (loc/tr :persons-will-be-screened-once-now))
              :selected? (= screening-method :one-time)}
             {:value :continuous
              :title (loc/tr :continuous-screening)
              :description (case modal-type
                             :legal-entities-and-key-persons
                             (loc/tr :legal-entities-and-key-persons-will-be-added-to-daily-screening)

                             :natural-persons
                             (loc/tr :persons-will-be-added-to-daily-screening))
              :selected? (= screening-method :continuous)}]

            submit #(rf/dispatch [::event/submit-send-to-screening-modal ctx])]
        [modal/view
         {:visible? open?
          :hide! #(rf/dispatch [::event/close-send-to-screening-modal ctx])}
         [:div title]
         [:div
          {:class "flex gap-2 justify-center overflow-hidden py-2"}
          (->> method-options
               (map (fn [{:keys [value title description selected?]}]
                      ^{:key (str value)}
                      [:div
                       {:class (uu/cm "p-2 border rounded w-72 hover:bg-base-regular cursor-pointer"
                                      (when selected?
                                        "ring ring-2 ring-primary-regular bg-season"))
                        :on-click #(rf/dispatch [::event/set-screening-method ctx value])}
                       [:div
                        {:class "flex items-center justify-between gap-1"}
                        [:p
                         {:class "font-semibold"}
                         title]
                        [:span
                         [:i {:class (uu/cm "fal fa-dot-circle"
                                            (if selected?
                                              "fas fa-dot-circle"
                                              "fa-circle"))}]]]
                       [:p
                        {:class "text-wrap mt-1 text-base-light-text-paler text-sm m-0"}
                        description]])))]
         [:<>
          [:div]
          [button/sm-primary-solid
           {:on-click submit
            :disabled? (or (not screening-method)
                           sending-to-screening?)}
           (if sending-to-screening?
             (str (loc/tr :sending) "...")
             (loc/tr :send-to-riskscreen))]]]))))

(defn person-counterparty-diligence-person-data-section
  [{:keys [person]}]
  (let [date-format @(rf/subscribe [::session-sub/tenant-date-format])]
    [:div
     {:class "flex flex-col gap-2"}
     [:p
      {:class "font-semibold"}
      (loc/tr :person)]
     [:div
      {:class "flex gap-x-20 gap-y-5 flex-wrap"}
      [:div
       [:p
        {:class "text-neutral-600 font-medium text-sm m-0"}
        (loc/tr :first-name)]
       [:p (:first-name person)]]
      [:div
       [:p
        {:class "text-neutral-600 font-medium text-sm m-0"}
        (loc/tr :last-name)]
       [:p (:last-name person)]]
      [:div
       [:p
        {:class "text-neutral-600 font-medium text-sm m-0"}
        (loc/tr :date-of-birth)]
       [:p (when (:date-of-birth person)
             (uu/format-date (:date-of-birth person) date-format))]]
      [:div
       [:p
        {:class "text-neutral-600 font-medium text-sm m-0"}
        (loc/tr :country)]
       [:p (when (:country person)
             (-> person
                 :country
                 country/get-label))]]]]))

(defn person-counterparty-diligence-screening-data-section
  [{:keys [screening-profile]}]
  (let [{:keys [screening-profile/sanction-status
                screening-profile/pep-status
                screening-profile/rca-status
                screening-profile/external-screening-id
                screening-profile/refresh-timestamp]}
        screening-profile
        tenant @(rf/subscribe [::session-sub/tenant])]
    [:div
     {:class "flex flex-col gap-2"}
     [:p
      {:class "font-semibold text-nowrap"}
      (loc/tr :screening-data)]
     (if screening-profile
       [:div
        {:class "flex gap-x-20 gap-y-5 flex-wrap"}
        [:div
         {:class "flex flex-col items-start"}
         [:p
          {:class "text-neutral-600 font-medium text-sm m-0 text-nowrap"}
          (loc/tr :sanction-status)]

         (when sanction-status
           [tables/sanction-status-badge
            {:sanction-status sanction-status
             :entity-type :person}])]
        [:div
         [:p
          {:class "text-neutral-600 font-medium text-sm m-0 text-nowrap"}
          (loc/tr :screening-profile/pep-status)]
         [:p (if pep-status
               (loc/tr :true)
               (loc/tr :false))]]
        [:div
         [:p
          {:class "text-neutral-600 font-medium text-sm m-0 text-nowrap"}
          (loc/tr :screening-profile/rca-status)]
         [:p (if rca-status
               (loc/tr :true)
               (loc/tr :false))]]
        [:div
         [:p
          {:class "text-neutral-600 font-medium text-sm m-0 text-nowrap"}
          (loc/tr :refreshed-at)]

         (when refresh-timestamp
           [:p (uu/display-datetime-timestamp tenant refresh-timestamp)])]

        [:div
         [:p
          {:class "text-neutral-600 font-medium text-sm m-0 text-nowrap"}
          (loc/tr :riskscreen-link)]
         [:a
          {:href   (model/entity-risk-screen-url external-screening-id)
           :target "_blank"}
          (loc/tr :view-in-riskscreen)]
         [:p]]]
       [:p
        {:class "text-base-light-text-paler"}
        (loc/tr :no-screening-data-found)])]))

(defn person-counterparty-diligence-content
  [{:keys [ctx] :as props}]
  (let [natural-persons @(rf/subscribe [::sub/natural-persons ctx])
        person (first natural-persons)
        screening-profile (:screening-profile person)
        sending-to-screening? @(rf/subscribe [::sub/sending-to-screening? ctx])]
    (if person
      [:div
       {:class "flex flex-col gap-7"}
       [person-counterparty-diligence-person-data-section
        {:person person}]

       [person-counterparty-diligence-screening-data-section
        {:screening-profile screening-profile}]

       [:div
        {:class "flex items-center gap-y-5 flex-wrap"}
        [:div
         {:class "w-48"}
         [button/sm-primary-solid
          {:disabled? sending-to-screening?
           :on-click #(rf/dispatch [::event/send-to-one-time-screening
                                    ctx
                                    {:persons [person]}])}
          (if sending-to-screening?
            (str (loc/tr :sending) "...")
            (loc/tr :send-to-riskscreen))]]

        [continuous-screening-toggle props]]]

      [:p
       {:class "text-base-light-text-paler"}
       (loc/tr :add-at-least-first-name-and-last-name-to-send-person-to-screening)])))

(defn project-counterparty-diligence-content
  [{:keys [ctx] :as props}]
  (let [legal-entities @(rf/subscribe [::sub/legal-entities ctx])
        natural-persons @(rf/subscribe [::sub/natural-persons ctx])
        date-format @(rf/subscribe [::session-sub/tenant-date-format])]
    (if (or (seq legal-entities)
            (seq natural-persons))
      [:div
       {:class "flex flex-col gap-10"}
       (when (seq legal-entities)
         [:div
          {:class "flex flex-col gap-2"}
          [:p
           {:class "font-semibold"}
           (loc/tr :legal-entities)]

          [tables/legal-entities-table
           (assoc props
                  :legal-entities legal-entities
                  :expandable? true
                  :row-selection? true
                  :date-format date-format)]

          [:div
           [open-send-to-screening-modal-button
            (assoc props
                   :modal-type :legal-entities-and-key-persons)]]])

       (when (seq natural-persons)
         [:div
          {:class "flex flex-col gap-2"}
          [:p
           {:class "font-semibold"}
           (loc/tr :natural-persons)]

          [tables/natural-persons-table
           (assoc props
                  :natural-persons natural-persons
                  :row-selection? true
                  :date-format date-format)]

          [:div
           [open-send-to-screening-modal-button
            (assoc props
                   :modal-type :natural-persons)]]])]
      [:div
       [:p
        {:class "text-base-light-text-paler"}
        (loc/tr :no-legal-entities-or-persons-found)]])))

(defn company-counterparty-diligence-content
  [{:keys [ctx] :as props}]
  (let [legal-entities @(rf/subscribe [::sub/legal-entities ctx])
        legal-entity (first legal-entities)
        key-persons (:key-persons legal-entity)
        sending-to-screening? @(rf/subscribe [::sub/sending-to-screening? ctx])
        date-format @(rf/subscribe [::session-sub/tenant-date-format])]
    (if legal-entity
      [:div
       {:class "flex flex-col gap-10"}
       [:div
        {:class "flex flex-col gap-2"}
        [:p
         {:class "font-semibold"}
         (loc/tr :legal-entity)]
        [tables/legal-entities-table
         (assoc props
                :legal-entities [legal-entity]
                :date-format date-format)]]

       [:div
        {:class "flex flex-col gap-2"}
        [:p
         {:class "font-semibold"}
         (loc/tr :key-persons)]
        (if (seq key-persons)
          [tables/legal-entity-key-persons-table
           (assoc props
                  :key-persons (:key-persons legal-entity)
                  :date-format date-format)]
          [:p
           {:class "text-base-light-text-paler"}
           (loc/tr :no-key-persons-found)])]

       [:div
        {:class "flex items-center"}
        [:div
         {:class "w-48"}
         [button/sm-primary-solid
          {:disabled? sending-to-screening?
           :on-click #(rf/dispatch [::event/send-to-one-time-screening
                                    ctx
                                    {:persons key-persons
                                     :legal-entities [legal-entity]}])}
          (if sending-to-screening?
            (str (loc/tr :sending) "...")
            (loc/tr :send-to-riskscreen))]]

        [continuous-screening-toggle props]]]

      [:div
       [:p
        {:class "text-base-light-text-paler"}
        (loc/tr :add-at-least-company-name-to-send-to-screening)]])))

(defn content
  [{:keys [ctx] :as props}]
  (let [counterparty-diligence @(rf/subscribe [::sub/counterparty-diligence ctx])]
    (case (:entity/type counterparty-diligence)
      :entity.type/person-counterparty-diligence
      [person-counterparty-diligence-content props]

      :entity.type/project-counterparty-diligence
      [project-counterparty-diligence-content props]

      :entity.type/company-counterparty-diligence
      [company-counterparty-diligence-content props]

      [:div])))

(defn view
  [{:keys [card] :as props}]
  [card-container/view
   {}
   [:div
    {:class "flex flex-col gap-4 mb-4"}
    [:div
     [:div
      {:class "flex justify-between"}
      [card-title/view (:card/title card)]]]
    [content props]
    [send-to-screening-modal props]]])
